import { NgTemplateOutlet } from '@angular/common';
import { Component, signal, TemplateRef, WritableSignal } from '@angular/core';

@Component({
  imports: [NgTemplateOutlet],
  selector: 'siat-event-custom-tooltip',
  template: `
    @if (contentTemplate()) {
      <ng-container
        *ngTemplateOutlet="contentTemplate(); context: context()"
      ></ng-container>
    } @else {
      {{ text() }}
    }
  `,
})
export class EventPopoverTooltipComponent {
  /**
   * This is simple text which is to be shown in the tooltip
   */
  text: WritableSignal<string> = signal('');

  /**
   * This provides finer control on the content to be visible on the tooltip.
   */
  contentTemplate: WritableSignal<TemplateRef<unknown> | null> = signal(null);

  /**
   * This provides context to the contentTemplate
   */
  context: WritableSignal<unknown> = signal(null);
}
